import _ from 'lodash';

export const queryKeys = {
  employees: (isFullList, page, search, status, params) => [
    'employees',
    isFullList,
    page,
    search,
    status,
    params,
  ],
  employee: (id) => ['employees', _.toString(id)],
  employeeProfile: (id) => ['employeesProfile', _.toString(id)],
  requests: (params, isFullList) => ['requests', ...params, isFullList],
  request: (id) => ['request', id],
  jobs: (page, search, payload) => ['jobs', page, search, payload],
  job: (id, params) => ['job', _.toString(id), params],
  searchItems: (query, page) => ['searchItems', query, page],
  candidates: (page, search, sortBy, params) => [
    'candidates',
    page,
    search,
    sortBy,
    params,
  ],
  candidate: (id) => ['candidate', _.toString(id)],
  talentGroups: () => ['talent_groups'],
  talentGroup: (id) => ['talent_group', _.toString(id)],
  user: () => ['am_user'],
  employeeSchema: () => ['employeeSchema'],
  employeeProfileSchema: () => ['employeeProfileSchema'],
  notes: (contentId, contentType) => ['notes', contentId, contentType],
  files: (contentId, contentType, parentId, userId, canManage, ...params) => [
    'files',
    contentId,
    contentType,
    parentId,
    userId,
    canManage,
    params,
  ],
  notifications: (status, payload) => ['push_notifications', status, payload],
  trainings: () => ['trainings'],
  trainingsCategories: (payload) => ['trainingsCategories', payload],
  timeOffPolicies: (isFullList, employeeId = '') => [
    'timeOffPolicies',
    employeeId,
    isFullList,
  ],
  timeOffCategories: (isFullList) => ['timeOffCategories', isFullList],
  timeOffRecords: (isFullList, ...params) => [
    'timeOffRecords',
    isFullList,
    params,
  ],
  userPolicy: (userId) => ['userPolicy', userId],
  policy: (id) => ['policy', id],
  employeePolicyList: (userId) => ['employeePolicy', userId],
  performanceCycles: () => ['performanceCycles'],
  performanceCycle: (id) => ['performanceCycle', _.toString(id)],
  surveys: (params) => ['surveys', ...params],
  survey: (id) => ['survey', id],
  users: (page, search) => ['users', page, search],
  groupedPermissions: () => ['groupedPermissions'],
  userTrainings: (id) => ['userTrainings', id],
  userRecords: (id, ...params) => ['userRecords', id, params],
  jobTitles: () => ['jobTitles'],
  departments: () => ['departments'],
  locations: () => ['locations'],
  divisions: () => ['divisions'],
  jobInformationList: (employeeId) => ['jobInformationList', employeeId],
  tasksList: (params) => ['tasksList', params],
  tasks: (params) => ['tasks', params],
  employeeBoardingList: (id, params) => ['employeeBoardingList', id, params],
  candidateSource: () => ['candidateSource'],
  candidateStatuses: () => ['candidateStatuses'],
  emailTemplates: () => ['emailTemplates'],
  offerTemplates: () => ['offerTemplates'],
  candidateOffer: (hash) => ['candidateOffer', hash],
  templateVariables: () => ['templateVariables'],
  manageRequest: (id) => ['manageRequest', _.toString(id)],
  employeeRequest: (id) => ['employeeRequest', _.toString(id)],
  dashboardInfo: () => ['dashboardInfo'],
  lookups: ({ models = [], ...rest }) => ['lookups', models, rest],
  headCountReport: (params) => ['headCountReport', params],
  isValidResetPasswordToken: (token) => ['isValidResetPasswordToken', token],
  employeeStatuses: () => ['employeeStatuses'],
  employeeStatusRecords: (employeeId) => [
    'employeeStatusRecords',
    _.toString(employeeId),
  ],
  reasons: (type) => ['reasons', type],
  paySchedules: () => ['paySchedules'],
  employeeCompensationRecords: (id) => [
    'employeeCompensationRecords',
    _.toString(id),
  ],
  employeeOrgTree: () => ['employeeOrgTree'],
  employeeBonusRecords: (id) => ['employeeBonusRecords', _.toString(id)],
  employeeAssessmentSurveys: (id, payload) => [
    'employeeAssessmentSurveys',
    payload,
    _.toString(id),
  ],
  totalEmployeesByJobInfoFilter: (filter) => [
    'totalEmployeesByJobInfoFilter',
    filter,
  ],
  assetCategories: () => ['assetCategories'],
  employeeAssets: (employeeId) => ['employeeAssets', _.toString(employeeId)],
  employeeSubordinates: (employeeId, subordinateIds) => [
    'employeeSubordinates',
    _.toString(employeeId),
    subordinateIds,
  ],
  oauthLogin: (provider) => ['oauthLogin', provider],
  userTokenProvider: (provider) => ['userTokenProvider', provider],
  companyActiveIntegrations: (companyId) => [
    'companyActiveIntegrations',
    companyId,
  ],
  integrations: () => ['integrations'],
  fileBlob: (fileId) => ['fileBlob', fileId],
  buildVersion: () => ['buildVersion'],
  allRoles: (payload) => ['allRoles', payload],
  compensationGroups: () => ['compensationGroups'],
  compensationBands: () => ['compensationBands'],
  calendarData: (params) => ['calendarData', params],
  eventTypes: () => ['eventTypes'],
  timeOffBalance: (payload) => ['timeOffBalance', payload],
  holidays: (payload) => ['holidays', payload],
  widgets: () => ['widgets'],
  employeeHolidays: (payload) => ['employeeHolidays', payload],
  candidatesOffers: (payload) => ['candidatesOffers', payload],
  companyLinksCategories: () => ['companyLinksCategories'],
  companyLinks: () => ['companyLinks'],
  announcements: (payload) => ['announcements', payload],
  announcement: (announcementId) => ['announcement', announcementId],
  jobOpenings: (params) => ['jobOpenings', params],
  jobOpening: (id) => ['jobOpening', id],
  requestsCount: (payload) => ['requestsCount', payload],
  satisfactionSurvey: () => ['satisfactionSurvey'],
  satisfactionSurveyByHash: (hash) => ['satisfactionSurveyByHash', hash],
  satisfactionDates: () => ['satisfactionDates'],
  satisfactionInterval: (payload) => ['satisfactionInterval', payload],
  satisfactionResponses: (payload) => ['satisfactionResponses', payload],
  satisfactionSurveyUpcomingDates: (payload) => ['upcomingDates', payload],
  payrollReportData: (payload) => ['payrollReportData', payload],
  timeOffUsageData: (payload) => ['timeOffUsageData', payload],
  salaryHistory: (payload) => ['salaryHistory', payload],
  audit: (payload) => ['audit', payload],
  auditFilters: () => ['auditFilters'],
  employeeTimesheetRecords: (payload) => ['employeeTimesheetRecords', payload],
  timeTrackingGroups: () => ['timeTrackingGroups'],
  loadPayrolls: (payload) => ['loadPayrolls', payload],
  loadPayrollReport: (params) => ['loadPayrollReport', params],
  hirePackets: () => ['hirePackets'],
  hirePacketVariables: () => ['hirePacketVariables'],
  workPatterns: () => ['workPatterns'],
  employeeWorkPatterns: (employeeId) => [
    'employeeWorkPatterns',
    _.toString(employeeId),
  ],
  employeeExtraPayRecords: (id) => ['employeeExtraPayRecords', _.toString(id)],
  extraPayByPayroll: (payrollId) => [
    'extraPayByPayroll',
    _.toString(payrollId),
  ],
  employeePayslips: (userId, params) => [
    'employeePayslips',
    _.toString(userId),
    params,
  ],
  employeeAllowances: (userId) => ['employeeAllowances', _.toString(userId)],
  employeeDeductions: (userId) => ['employeeDeductions', _.toString(userId)],
  employeeAllowancesDeductions: (userId) => [
    'employeeAllowancesDeductions',
    _.toString(userId),
  ],
  employeeExtraPays: (userId, fromDate, toDate) => [
    'employeeExtraPays',
    _.toString(userId),
    fromDate,
    toDate,
  ],
  taxBands: (params) => ['taxBands', params],
  taxBand: (id) => ['taxBand', _.toString(id)],
  allowances: (params) => ['allowances', params],
  allowance: (id) => ['allowance', _.toString(id)],
  deductions: (params) => ['deductions', params],
  deduction: (id) => ['deduction', _.toString(id)],
};
